<template>
  <ContactSection
    :title="t('contact.title')"
    :description="t('contact.description')"
    :button-name="t('contact.item-button')"
    :button-url="`/${locale}/marketplace/help/contact-us`"
    :button-id="isCN ? 'tracking_contactUs' : undefined"
  />
</template>

<script setup lang="ts">
  const { t, locale } = useI18n();
  const { isCN } = useLanguage();
</script>
